"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AnalyticsService = exports.EventCategory = void 0;
const core_api_1 = require("@ikegps/core-api");
const mobx_1 = require("mobx");
const index_1 = require("./index");
var EventCategory;
(function (EventCategory) {
    EventCategory["Auth"] = "Authentication";
    EventCategory["BigMap"] = "BigMap";
    EventCategory["Collection"] = "Collection";
    EventCategory["Export"] = "Export";
    EventCategory["Form"] = "Form";
    EventCategory["Import"] = "Import";
    EventCategory["Mutate"] = "Mutate";
    EventCategory["Performance"] = "Performance";
    EventCategory["Route"] = "Route";
    EventCategory["Upload"] = "Upload";
    EventCategory["FormImportUpload"] = "FormImportUpload";
})(EventCategory || (exports.EventCategory = EventCategory = {}));
class AnalyticsService {
    constructor() {
        this.__priority = 100;
        this.EventCategory = EventCategory;
        this.DEBOUNCE_TIME = 1000;
        this.TimingEventType = core_api_1.TimingEventType;
        this.TimingEventAction = core_api_1.TimingEventAction;
    }
    init() {
        (0, mobx_1.reaction)((_) => index_1.Services.User.current, (_) => this.setUser(), { fireImmediately: true });
        (0, mobx_1.reaction)((_) => index_1.Services.Department.current, (_) => this.setDepartment(), { fireImmediately: true });
        // Track that the system started
        this.trackEvent(EventCategory.Auth, 'page:init', 'init', 1);
    }
    setUser() {
        if (index_1.Services.Window.window.ga == null) {
            return;
        }
        const user = index_1.Services.User.current;
        if (user == null) {
            index_1.Services.Window.window.ga('set', 'userId', null);
        }
        else {
            index_1.Services.Window.window.ga('set', 'userId', user.objectId);
        }
    }
    setDepartment() {
        if (index_1.Services.Window.window.ga == null) {
            return;
        }
        const department = index_1.Services.Department.current;
        if (department == null) {
            index_1.Services.Window.window.ga('set', 'dimension1', null);
        }
        else {
            index_1.Services.Window.window.ga('set', 'dimension1', department.objectId);
        }
    }
    trackTiming(type, action, collectionId, recordedAt) {
        if (index_1.Services.User.hasUser) {
            const data = {
                events: [
                    {
                        type,
                        action,
                        collectionId,
                        recordedAt: recordedAt.toISOString(),
                    },
                ],
            };
            // eslint-disable-next-line @typescript-eslint/no-floating-promises
            index_1.Services.Department.rest.Event.create(data);
        }
    }
    /**
     * Track event.
     *
     * @param category Typically the object that was interacted with (e.g. 'Collection')
     * @param action The type of interaction (e.g. 'brightness:increase')
     * @param label Useful for categorizing events (e.g. Id of object affected)
     * @param value A numeric value associated with the event (e.g. 42)
     */
    trackEvent(category, action, label, value) {
        if (index_1.Services.Window.window.ga == null) {
            return;
        }
        index_1.Services.Window.window.ga('send', 'event', category, action, label, value);
    }
}
exports.AnalyticsService = AnalyticsService;
//# sourceMappingURL=analytics.service.js.map